<div class="row claim-overview pad-bottom-20">
  <p authCheck [permissionName]="'contactadjfrm_view'" [checkAction]="'remove'">
    Below is information about your claim.
    <span [hidden]="!displayAdjuster"
      >If you have questions, please
      <a [dsRouterLink]="['/claims/contact-adjuster', claim.claimNumber]">contact your adjuster</a>
      and we’ll be happy to help.</span
    >
  </p>
  <div class="column twelve">
    <div class="row pad-vertical-10">
      <div class="column twelve md-three label">Claim reported for:</div>
      <div class="column twelve md-nine">
        <app-claim-risk [claim]="claim"></app-claim-risk>
      </div>
    </div>
    <div class="row pad-vertical-10">
      <div class="column twelve md-three label">Status:</div>
      <div class="column twelve md-nine">
        @switch (claim?.claimStatus) {
          @case ('OPEN') {
            <span> Opened on {{ claim?.openDate | date: 'shortDate' }} </span>
          }
          @case ('CLOSED') {
            <span> Closed on {{ claim?.closedDate | date: 'shortDate' }} </span>
          }
        }
      </div>
    </div>
    @if (displayAdjuster) {
      <div class="row pad-vertical-10">
        <div class="column twelve md-three label">Adjuster:</div>
        <div class="column twelve md-nine">{{ claim?.primaryFileHandler?.name }}</div>
      </div>
    }
    @if (!!adjuster.phone) {
      <div class="row pad-vertical-10">
        <div class="column twelve md-three label">Adjuster Phone Number:</div>
        <div class="column twelve md-nine">
          {{ adjuster.phone | adjusterPhoneNumberFormatter }}
        </div>
      </div>
    }
    @if (!!(claim?.primaryFileHandler?.emails)[0]?.emailAddress) {
      <div class="row pad-vertical-10">
        <div class="column twelve md-three label">Adjuster Email:</div>
        <div class="column twelve md-nine">
          {{ claim.primaryFileHandler.emails[0].emailAddress }}
        </div>
      </div>
    }
  </div>
</div>
<div class="row callToAction">
  <span class="md-float-right">
    <button ds-button type="button" (click)="back()">Back to Claims</button>
  </span>
</div>
